import { render, staticRenderFns } from "./document-notification.vue?vue&type=template&id=31afbf1c&"
import script from "./document-notification.vue?vue&type=script&lang=js&"
export * from "./document-notification.vue?vue&type=script&lang=js&"
import style0 from "./document-notification.vue?vue&type=style&index=0&id=31afbf1c&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31afbf1c')) {
      api.createRecord('31afbf1c', component.options)
    } else {
      api.reload('31afbf1c', component.options)
    }
    module.hot.accept("./document-notification.vue?vue&type=template&id=31afbf1c&", function () {
      api.rerender('31afbf1c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/documents/document-notification.vue"
export default component.exports